/* ZO•ON collection filters (Sept 2026) – mettasport.is-style filter panel with live counts.
   Replaces the theme's old English filter dropdowns (hidden only once this has loaded).
   Works on the products already on the page: Flokkur (from the product title), Litur, Stærð,
   Verð and Á afslætti. Several choices in one group = OR, across groups = AND.
   Styles: end of assets/zoon-premium.css. Loaded on collection pages from snippets/zoon-features.liquid. */
(function () {
  'use strict';
  var Z = window.ZOON || {};
  var EN = !!Z.en;
  var L = EN ? {
    filter: 'Filter', close: 'Close', clear: 'Clear all', show1: 'Show 1 product', showN: 'Show {n} products',
    none: 'No products match these filters.', noneClear: 'Clear filters',
    g: { cat: 'Category', color: 'Colour', size: 'Size', price: 'Price', sale: 'Offers' }, sale: 'On sale',
    all: 'View all', dense: 'Smaller photos, more per row', large: 'Larger photos',
    sort: 'Sort by', sorts: [['created-descending', 'Newest'], ['best-selling', 'Best selling'], ['price-ascending', 'Price: low to high'], ['price-descending', 'Price: high to low']]
  } : {
    filter: 'Sía', close: 'Loka', clear: 'Hreinsa allt', show1: 'Sýna 1 vöru', showN: 'Sýna {n} vörur',
    none: 'Engar vörur passa við þessar síur.', noneClear: 'Hreinsa síur',
    g: { cat: 'Flokkur', color: 'Litur', size: 'Stærð', price: 'Verð', sale: 'Tilboð' }, sale: 'Á afslætti',
    all: 'Sjá allt', dense: 'Minni myndir, fleiri í röð', large: 'Stærri myndir',
    sort: 'Raða eftir', sorts: [['created-descending', 'Nýjast'], ['best-selling', 'Mest selt'], ['price-ascending', 'Verð: lægst fyrst'], ['price-descending', 'Verð: hæst fyrst']]
  };

  /* Categories, matched against the product title (Icelandic and English titles), then tags */
  var CATS = [
    { k: 'vest', is: 'Vesti', en: 'Vests', re: /vesti\b|\bvest\b|gilet/ },
    { k: 'parka', is: 'Úlpur og kápur', en: 'Parkas & coats', re: /úlpa|úlpur|kápa|parka|\bcoat\b/ },
    { k: 'jacket', is: 'Jakkar', en: 'Jackets', re: /jakki|jakkar|jacket|anorak|windbreaker/ },
    { k: 'sweater', is: 'Peysur', en: 'Sweaters & hoodies', re: /peysa|peysur|hoodie|sweater|sweatshirt|fleece|pullover|cardigan/ },
    { k: 'top', is: 'Bolir', en: 'Tops & T-shirts', re: /bolur|bolir|t-shirt|\btee\b|shirt|base ?layer|\btop\b/ },
    { k: 'pants', is: 'Buxur', en: 'Pants', re: /buxur|pants|trousers|tights|shorts|leggings/ },
    { k: 'hat', is: 'Húfur', en: 'Hats', re: /húfa|húfur|beanie|\bhat\b|headband|ennisband|buff|hálskragi|neck/ },
    { k: 'gloves', is: 'Hanskar og vettlingar', en: 'Gloves & mittens', re: /hanskar|gloves|vettling|mittens/ },
    { k: 'bag', is: 'Töskur', en: 'Bags', re: /taska|töskur|bakpoki|backpack|\bbag\b|pouch/ },
    { k: 'acc', is: 'Fylgihlutir', en: 'Accessories', re: /belti|belt|sokkar|socks|accessor|fylgihlut/ }
  ];
  var TAGCATS = { jackets: 'jacket', 'rain jacket': 'jacket', parka: 'parka', úlpur: 'parka', tops: 'top',
    bottoms: 'pants', pants: 'pants', hats: 'hat', beanie: 'hat', gloves: 'gloves', bags: 'bag', bag: 'bag',
    vest: 'vest', accessories: 'acc' };

  /* Colour families: [key, IS, EN, swatch, words] – checked in this order */
  var COLORS = [
    ['grey', 'Grár', 'Grey', '#9b9b9b', ['melange', 'heather']],
    ['navy', 'Dökkblár', 'Navy', '#1f2a44', ['navy', 'midnight']],
    ['teal', 'Grænblár', 'Turquoise', '#2aa3a0', ['turquoise', 'teal', 'aqua', 'petrol']],
    ['black', 'Svartur', 'Black', '#111111', ['black', 'onyx', 'phantom']],
    ['white', 'Hvítur', 'White', '#ffffff', ['white', 'ivory', 'cream', 'snow', 'off white']],
    ['grey', 'Grár', 'Grey', '#9b9b9b', ['grey', 'gray', 'charcoal', 'silver', 'graphite', 'asphalt']],
    ['blue', 'Blár', 'Blue', '#2d5da8', ['blue', 'ocean', 'sky', 'denim', 'cobalt']],
    ['green', 'Grænn', 'Green', '#4a6b4f', ['green', 'olive', 'khaki', 'sage', 'moss', 'forest', 'pine', 'mint']],
    ['red', 'Rauður', 'Red', '#b3261e', ['red', 'burgundy', 'wine', 'bordeaux', 'maroon', 'cherry']],
    ['pink', 'Bleikur', 'Pink', '#e8a3b5', ['pink', 'rose', 'blush', 'fuchsia', 'coral']],
    ['orange', 'Appelsínugulur', 'Orange', '#e07a2e', ['orange', 'rust', 'melon', 'apricot', 'peach']],
    ['yellow', 'Gulur', 'Yellow', '#e7c23a', ['yellow', 'mustard', 'lemon', 'gold']],
    ['beige', 'Sandur / beige', 'Sand / beige', '#cdb89a', ['sand', 'beige', 'driftwood', 'stone', 'taupe', 'camel', 'tan', 'oat', 'latte']],
    ['brown', 'Brúnn', 'Brown', '#6b4a32', ['brown', 'chocolate', 'coffee', 'mocca', 'mocha']],
    ['purple', 'Fjólublár', 'Purple', '#7b5ea7', ['purple', 'lilac', 'lavender', 'plum', 'violet']]
  ];
  var SIZE_ORDER = ['XXS', 'XS', 'XS/S', 'S', 'S/M', 'M', 'M/L', 'L', 'L/XL', 'XL', 'XL/XXL', 'XXL', '3XL', '4XL', '5XL'];
  var PRICES = [[0, 10000], [10000, 20000], [20000, 30000], [30000, 50000], [50000, 1e12]];

  function fmt(n) { var s = String(n).replace(/\B(?=(\d{3})+(?!\d))/g, EN ? ',' : '.'); return s; }
  function priceLabel(b) {
    var cur = EN ? ' ISK' : ' kr.';
    if (b[0] === 0) return (EN ? 'Under ' : 'Undir ') + fmt(b[1]) + cur;
    if (b[1] > 1e11) return fmt(b[0]) + cur + (EN ? ' and over' : ' og yfir');
    return fmt(b[0]) + ' – ' + fmt(b[1]) + cur;
  }
  function colorFamily(v) {
    v = String(v || '').toLowerCase().trim();
    if (!v) return null;
    for (var i = 0; i < COLORS.length; i++) {
      for (var j = 0; j < COLORS[i][4].length; j++) if (v.indexOf(COLORS[i][4][j]) !== -1) return COLORS[i][0];
    }
    return 'x:' + v;
  }
  function colorMeta(key) {
    if (key.indexOf('x:') === 0) { var raw = key.slice(2); return { label: raw.charAt(0).toUpperCase() + raw.slice(1), sw: '' }; }
    for (var i = 0; i < COLORS.length; i++) if (COLORS[i][0] === key) return { label: EN ? COLORS[i][2] : COLORS[i][1], sw: COLORS[i][3] };
    return { label: key, sw: '' };
  }
  function normSize(s) {
    s = String(s || '').toUpperCase().replace(/\s+/g, ' ').trim();
    if (!s || s === 'DEFAULT TITLE') return null;
    if (s === '2XL') s = 'XXL';
    if (s === 'XXXL') s = '3XL';
    if (s === 'XXXXL') s = '4XL';
    return s;
  }
  function sizeRank(s) {
    var i = SIZE_ORDER.indexOf(s);
    if (i !== -1) return i;
    var n = parseFloat(s);
    if (!isNaN(n) && /^\d/.test(s)) return 100 + n;
    return 100000;
  }
  function catOf(title, tags) {
    var t = String(title || '').toLowerCase();
    for (var i = 0; i < CATS.length; i++) if (CATS[i].re.test(t)) return CATS[i].k;
    for (var j = 0; j < tags.length; j++) { var c = TAGCATS[String(tags[j]).toLowerCase()]; if (c) return c; }
    return null;
  }
  function catLabel(k) { for (var i = 0; i < CATS.length; i++) if (CATS[i].k === k) return EN ? CATS[i].en : CATS[i].is; return k; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function store(key, val) {
    try {
      if (val === undefined) return JSON.parse(sessionStorage.getItem(key) || 'null');
      sessionStorage.setItem(key, JSON.stringify(val));
    } catch (e) { return null; }
  }

  function init() {
    var grid = document.querySelector('.collection__product-grid');
    var bar = document.querySelector('.filter-and-sort');
    if (!grid || !bar || grid.getAttribute('data-zf')) return;
    grid.setAttribute('data-zf', '1');

    /* ---- read the products on the page ---- */
    var items = [];
    grid.querySelectorAll(':scope > .product-item').forEach(function (li) {
      var opts = {}, tags = [];
      try { opts = JSON.parse(li.getAttribute('data-options') || '{}'); } catch (e) {}
      try { tags = JSON.parse(li.getAttribute('data-tags') || '[]'); } catch (e) {}
      var titleEl = li.querySelector('.product-item__title');
      var colors = {}, sizes = {};
      (opts.color || []).forEach(function (c) { var f = colorFamily(c); if (f) colors[f] = 1; });
      (opts.size || []).forEach(function (s) { var n = normSize(s); if (n) sizes[n] = 1; });
      var price = parseFloat(li.getAttribute('data-price'));
      var pb = null;
      if (!isNaN(price)) for (var i = 0; i < PRICES.length; i++) if (price >= PRICES[i][0] && price < PRICES[i][1]) { pb = String(i); break; }
      items.push({
        el: li,
        f: {
          cat: (function (c) { var o = {}; if (c) o[c] = 1; return o; })(catOf(titleEl ? titleEl.textContent : '', tags)),
          color: colors, size: sizes,
          price: pb === null ? {} : (function () { var o = {}; o[pb] = 1; return o; })(),
          sale: li.querySelector('.sale-badge') ? { yes: 1 } : {}
        }
      });
    });
    if (items.length < 4) return; /* tiny collections don't need filters */

    var isk = !(window.Shopify && Shopify.currency && Shopify.currency.active && Shopify.currency.active !== 'ISK');

    /* ---- build the option lists (only groups with a real choice) ---- */
    var groups = [];
    function collect(key) { var seen = {}; items.forEach(function (it) { for (var v in it.f[key]) seen[v] = 1; }); return Object.keys(seen); }
    var cats = collect('cat').sort(function (a, b) {
      var ia = 0, ib = 0; CATS.forEach(function (c, i) { if (c.k === a) ia = i; if (c.k === b) ib = i; }); return ia - ib;
    });
    if (cats.length > 1) groups.push({ key: 'cat', opts: cats.map(function (k) { return { v: k, label: catLabel(k) }; }) });
    var cols = collect('color').sort(function (a, b) {
      var ia = 999, ib = 999; COLORS.forEach(function (c, i) { if (c[0] === a && ia === 999) ia = i; if (c[0] === b && ib === 999) ib = i; });
      return ia - ib || (a < b ? -1 : 1);
    });
    if (cols.length > 1) groups.push({ key: 'color', opts: cols.map(function (k) { var m = colorMeta(k); return { v: k, label: m.label, sw: m.sw }; }) });
    var sizes = collect('size').sort(function (a, b) { return sizeRank(a) - sizeRank(b) || (a < b ? -1 : 1); });
    if (sizes.length > 1) groups.push({ key: 'size', opts: sizes.map(function (k) { return { v: k, label: k }; }), boxes: true });
    if (isk) {
      var pbs = collect('price').sort();
      if (pbs.length > 1) groups.push({ key: 'price', opts: pbs.map(function (k) { return { v: k, label: priceLabel(PRICES[+k]) }; }) });
    }
    var saleCount = items.filter(function (it) { return it.f.sale.yes; }).length;
    if (saleCount && saleCount < items.length) groups.push({ key: 'sale', opts: [{ v: 'yes', label: L.sale }] });
    if (!groups.length) return;

    /* ---- state ---- */
    var skey = 'zoon_filters:' + location.pathname;
    var state = {};
    var saved = store(skey);
    groups.forEach(function (g) {
      state[g.key] = {};
      if (saved && saved[g.key]) saved[g.key].forEach(function (v) {
        if (g.opts.some(function (o) { return o.v === v; })) state[g.key][v] = 1;
      });
    });
    function activeCount() { var n = 0; for (var g in state) n += Object.keys(state[g]).length; return n; }
    function matches(it, skip) {
      for (var g in state) {
        if (g === skip) continue;
        var sel = Object.keys(state[g]);
        if (!sel.length) continue;
        var ok = false;
        for (var i = 0; i < sel.length; i++) if (it.f[g][sel[i]]) { ok = true; break; }
        if (!ok) return false;
      }
      return true;
    }

    /* ---- markup: bar + drawer ---- */
    var zbar = document.createElement('div');
    zbar.className = 'zf-bar';
    /* Zara-style row of sub-category links ("Sjá allt · Jakkar · Peysur …") – one tap filters */
    var catGroup = null;
    groups.forEach(function (g) { if (g.key === 'cat') catGroup = g; });
    var nav = '';
    if (catGroup) {
      nav = '<nav class="zf-catnav" aria-label="' + L.g.cat + '"><button type="button" class="zf-cat" data-v="">' + L.all + '</button>';
      catGroup.opts.forEach(function (o) { nav += '<button type="button" class="zf-cat" data-v="' + esc(o.v) + '">' + esc(o.label) + '</button>'; });
      nav += '</nav>';
    }
    /* Zara-style view switch: smaller photos (more per row) or larger photos */
    var view = '<div class="zf-view" role="group">' +
      '<button type="button" class="zf-view-btn" data-view="dense" aria-label="' + L.dense + '" title="' + L.dense + '"><svg viewBox="0 0 20 20" aria-hidden="true"><rect x="2" y="2" width="6.5" height="6.5"/><rect x="11.5" y="2" width="6.5" height="6.5"/><rect x="2" y="11.5" width="6.5" height="6.5"/><rect x="11.5" y="11.5" width="6.5" height="6.5"/></svg></button>' +
      '<button type="button" class="zf-view-btn" data-view="large" aria-label="' + L.large + '" title="' + L.large + '"><svg viewBox="0 0 20 20" aria-hidden="true"><rect x="3" y="2" width="14" height="16"/></svg></button></div>';
    zbar.innerHTML = nav + '<button type="button" class="zf-open" aria-haspopup="dialog"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M3 5h14M6 10h8M8.5 15h3" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round"/></svg><span>' +
      L.filter + '</span><span class="zf-badge" hidden></span></button><div class="zf-chips"></div>' + view;
    var row = bar.querySelector(':scope > .flex') || bar.firstElementChild;
    bar.insertBefore(zbar, row);
    /* Our own sort menu (replaces the theme's): Shopify sorts on the server via ?sort_by=, so the order is always
       exactly Shopify's and nothing is remembered between collections. The theme's old sort row is hidden. */
    var cur = Z.sortBy || '';
    var curLabel = '';
    var sortHtml = '<div class="zf-sort"><button type="button" class="zf-sort-btn" aria-haspopup="true" aria-expanded="false">' + L.sort;
    var menu = '<ul class="zf-sort-menu" role="menu">';
    L.sorts.forEach(function (s) {
      var u; try { u = new URL(location.href); u.searchParams.set('sort_by', s[0]); u.searchParams.delete('page'); u = u.pathname + u.search; } catch (e) { u = '?sort_by=' + s[0]; }
      if (s[0] === cur) curLabel = s[1];
      menu += '<li role="none"><a role="menuitem" href="' + esc(u) + '"' + (s[0] === cur ? ' class="is-on" aria-current="true"' : '') + '>' + esc(s[1]) + '</a></li>';
    });
    menu += '</ul>';
    sortHtml += (curLabel ? '<span class="zf-sort-cur">: ' + esc(curLabel) + '</span>' : '') + '<span class="zf-sort-chev" aria-hidden="true"></span></button>' + menu + '</div>';
    zbar.querySelector('.zf-view').insertAdjacentHTML('beforebegin', sortHtml);
    bar.classList.add('zf-sorted');
    var sortBox = zbar.querySelector('.zf-sort'), sortBtn = sortBox.querySelector('.zf-sort-btn');
    sortBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = sortBox.classList.toggle('is-open');
      sortBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) {
      if (!sortBox.contains(e.target)) { sortBox.classList.remove('is-open'); sortBtn.setAttribute('aria-expanded', 'false'); }
    });

    /* Keep Shopify's product order (newest first, or the chosen sort). If anything re-sorts the grid in the
       browser, put it back – and keep the theme's "load more" count (first N shown, rest hidden) intact. */
    var ordering = false;
    function enforceOrder() {
      var order = Z.order;
      if (!order || !order.length) return;
      var pos = {};
      order.forEach(function (h, i) { if (!(h in pos)) pos[h] = i; });
      var kids = Array.prototype.slice.call(grid.querySelectorAll(':scope > .product-item'));
      var sorted = kids.slice().sort(function (a, b) {
        var pa = pos[a.getAttribute('data-product')], pb = pos[b.getAttribute('data-product')];
        pa = pa === undefined ? 1e6 + kids.indexOf(a) : pa; pb = pb === undefined ? 1e6 + kids.indexOf(b) : pb;
        return pa - pb;
      });
      var same = true;
      for (var i = 0; i < kids.length; i++) if (kids[i] !== sorted[i]) { same = false; break; }
      if (same) return;
      var hiddenCount = kids.filter(function (li) { return li.classList.contains('visually-hidden') || li.hasAttribute('data-zf-vh'); }).length;
      var filtering = grid.classList.contains('zf-filtering');
      ordering = true;
      sorted.forEach(function (li, i) {
        grid.appendChild(li);
        var hide = i >= sorted.length - hiddenCount;
        if (filtering) {
          li.classList.remove('visually-hidden');
          if (hide) li.setAttribute('data-zf-vh', '1'); else li.removeAttribute('data-zf-vh');
        } else {
          li.classList.toggle('visually-hidden', hide);
          li.removeAttribute('data-zf-vh');
        }
      });
      setTimeout(function () { ordering = false; }, 0);
    }
    try { enforceOrder(); } catch (e) {}
    if ('MutationObserver' in window) {
      var ot;
      new MutationObserver(function () {
        if (ordering) return;
        clearTimeout(ot);
        ot = setTimeout(function () { try { enforceOrder(); } catch (e) {} }, 60);
      }).observe(grid, { childList: true });
    }
    window.addEventListener('load', function () { try { enforceOrder(); } catch (e) {} });

    var vkey = 'zoon_grid_view';
    function setView(v) {
      grid.classList.add('zg');
      grid.setAttribute('data-zg', v);
      zbar.querySelectorAll('.zf-view-btn').forEach(function (b) {
        var on = b.getAttribute('data-view') === v;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      try { localStorage.setItem(vkey, v); } catch (e) {}
    }
    var savedView = 'dense';
    try { savedView = localStorage.getItem(vkey) === 'large' ? 'large' : 'dense'; } catch (e) {}
    setView(savedView);
    zbar.querySelectorAll('.zf-view-btn').forEach(function (b) {
      b.addEventListener('click', function () { setView(b.getAttribute('data-view')); });
    });

    var overlay = document.createElement('div');
    overlay.className = 'zf-overlay';
    var panel = document.createElement('aside');
    panel.className = 'zf-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', L.filter);
    var html = '<div class="zf-head"><span class="zf-title">' + L.filter + '</span><button type="button" class="zf-close" aria-label="' + L.close + '">&times;</button></div><div class="zf-body">';
    groups.forEach(function (g, gi) {
      html += '<details class="zf-group" data-g="' + g.key + '"' + (gi < 3 || Object.keys(state[g.key]).length ? ' open' : '') + '><summary><span>' + L.g[g.key] +
        '</span><span class="zf-sel"></span><span class="zf-chev" aria-hidden="true"></span></summary><div class="zf-opts' + (g.boxes ? ' zf-opts--boxes' : '') + '">';
      g.opts.forEach(function (o) {
        html += '<button type="button" class="zf-opt" data-g="' + g.key + '" data-v="' + esc(o.v) + '" aria-pressed="false">' +
          (g.key === 'color' ? '<span class="zf-dot' + (o.sw === '#ffffff' ? ' zf-dot--light' : '') + '"' + (o.sw ? ' style="background:' + o.sw + '"' : '') + '></span>' : '') +
          (g.key !== 'color' && !g.boxes ? '<span class="zf-check" aria-hidden="true"></span>' : '') +
          '<span class="zf-label">' + esc(o.label) + '</span><span class="zf-n"></span></button>';
      });
      html += '</div></details>';
    });
    html += '</div><div class="zf-foot"><button type="button" class="zf-clear">' + L.clear + '</button><button type="button" class="zf-apply"></button></div>';
    panel.innerHTML = html;
    document.body.appendChild(overlay);
    document.body.appendChild(panel);

    var empty = document.createElement('div');
    empty.className = 'zf-empty';
    empty.hidden = true;
    empty.innerHTML = '<p>' + L.none + '</p><button type="button" class="zf-clear">' + L.noneClear + '</button>';
    grid.parentNode.insertBefore(empty, grid.nextSibling);

    /* ---- apply ---- */
    var countEl = null;
    function apply() {
      var any = activeCount() > 0;
      var shown = 0;
      grid.classList.toggle('zf-filtering', any);
      items.forEach(function (it) {
        var li = it.el;
        if (any) {
          /* the theme hides products beyond its "load more" limit – show every match while filtering */
          if (li.classList.contains('visually-hidden')) { li.classList.remove('visually-hidden'); li.setAttribute('data-zf-vh', '1'); }
        } else if (li.getAttribute('data-zf-vh')) {
          li.classList.add('visually-hidden'); li.removeAttribute('data-zf-vh');
        }
        var ok = matches(it);
        li.classList.toggle('zf-out', any && !ok);
        if (ok) shown++;
      });
      empty.hidden = !(any && shown === 0);
      /* counts per option, given the other groups' choices */
      panel.querySelectorAll('.zf-opt').forEach(function (b) {
        var g = b.getAttribute('data-g'), v = b.getAttribute('data-v');
        var n = 0;
        items.forEach(function (it) { if (it.f[g][v] && matches(it, g)) n++; });
        b.querySelector('.zf-n').textContent = n;
        var on = !!state[g][v];
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.classList.toggle('is-on', on);
        b.classList.toggle('is-zero', !n && !on);
      });
      panel.querySelectorAll('.zf-group').forEach(function (d) {
        var k = Object.keys(state[d.getAttribute('data-g')]).length;
        d.querySelector('.zf-sel').textContent = k ? '(' + k + ')' : '';
      });
      var total = any ? shown : items.length;
      panel.querySelector('.zf-apply').textContent = total === 1 ? L.show1 : L.showN.replace('{n}', total);
      var catSel = state.cat ? Object.keys(state.cat) : [];
      zbar.querySelectorAll('.zf-cat').forEach(function (b) {
        var v = b.getAttribute('data-v');
        var on = v ? (catSel.length === 1 && catSel[0] === v) : !catSel.length;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var badge = zbar.querySelector('.zf-badge');
      badge.hidden = !any;
      badge.textContent = activeCount();
      /* chips */
      var chips = '';
      groups.forEach(function (g) {
        if (g.key === 'cat' && catSel.length === 1) return; /* already shown underlined in the category row */
        g.opts.forEach(function (o) {
          if (state[g.key][o.v]) chips += '<button type="button" class="zf-chip" data-g="' + g.key + '" data-v="' + esc(o.v) + '">' + esc(o.label) + '<span aria-hidden="true">&times;</span></button>';
        });
      });
      if (chips) chips += '<button type="button" class="zf-chip zf-chip--clear zf-clear">' + L.clear + '</button>';
      zbar.querySelector('.zf-chips').innerHTML = chips;
      /* product count under the title */
      countEl = countEl || document.querySelector('.zoon-count');
      if (countEl) {
        if (!countEl.getAttribute('data-orig')) countEl.setAttribute('data-orig', countEl.textContent);
        countEl.textContent = any ? total + ' / ' + countEl.getAttribute('data-orig') : countEl.getAttribute('data-orig');
      }
      var out = {};
      for (var gk in state) out[gk] = Object.keys(state[gk]);
      store(skey, out);
    }

    /* ---- open / close ---- */
    var changed = false, lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      changed = false;
      document.documentElement.classList.add('zf-lock');
      overlay.classList.add('is-open');
      panel.classList.add('is-open');
      setTimeout(function () { var c = panel.querySelector('.zf-close'); if (c) c.focus(); }, 50);
    }
    function close() {
      document.documentElement.classList.remove('zf-lock');
      overlay.classList.remove('is-open');
      panel.classList.remove('is-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      if (changed) {
        var y = grid.getBoundingClientRect().top + window.pageYOffset - 180;
        if (window.pageYOffset > y) window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      }
    }
    function clearAll() { for (var g in state) state[g] = {}; changed = true; apply(); }

    zbar.querySelector('.zf-open').addEventListener('click', open);
    overlay.addEventListener('click', close);
    panel.querySelector('.zf-close').addEventListener('click', close);
    panel.querySelector('.zf-apply').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel.classList.contains('is-open')) close(); });
    panel.addEventListener('click', function (e) {
      var b = e.target.closest('.zf-opt');
      if (b) {
        var g = b.getAttribute('data-g'), v = b.getAttribute('data-v');
        if (state[g][v]) delete state[g][v]; else state[g][v] = 1;
        changed = true;
        apply();
        return;
      }
      if (e.target.closest('.zf-clear')) clearAll();
    });
    zbar.addEventListener('click', function (e) {
      var cb = e.target.closest('.zf-cat');
      if (cb) {
        var cv = cb.getAttribute('data-v');
        state.cat = {};
        if (cv) state.cat[cv] = 1;
        apply();
        var y = grid.getBoundingClientRect().top + window.pageYOffset - 200;
        if (window.pageYOffset > y) window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
        return;
      }
      var c = e.target.closest('.zf-chip');
      if (!c) return;
      if (c.classList.contains('zf-clear')) { clearAll(); return; }
      delete state[c.getAttribute('data-g')][c.getAttribute('data-v')];
      apply();
    });
    empty.querySelector('.zf-clear').addEventListener('click', clearAll);

    document.documentElement.classList.add('zf-ready');
    apply();
  }

  /* Icelandic labels for the theme's sort menu */
  function translateSort() {
    if (EN) return;
    var map = { 'Sort By': 'Raða eftir', 'Sort By:': 'Raða eftir:', 'Featured': 'Mælt með', 'Newest': 'Nýjast', 'Best Selling': 'Mest selt',
      'Price: High to Low': 'Verð: hæst fyrst', 'Price: Low to High': 'Verð: lægst fyrst' };
    document.querySelectorAll('.filter-and-sort').forEach(function (root) {
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, hits = [];
      while ((n = w.nextNode())) { var k = n.nodeValue.trim(); if (map[k]) hits.push(n); }
      hits.forEach(function (node) { var k = node.nodeValue.trim(); node.nodeValue = node.nodeValue.replace(k, map[k]); });
    });
  }

  function start() {
    try { init(); } catch (e) { document.documentElement.classList.remove('zf-ready'); }
    try { translateSort(); } catch (e) {}
    if ('MutationObserver' in window) {
      var t, root = document.querySelector('.filter-and-sort');
      if (root) new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { try { translateSort(); } catch (e) {} }, 100); })
        .observe(root, { childList: true, characterData: true, subtree: true });
    }
  }
  if (document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);
})();